import { Box, Button, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import Error404Image from '../../assets/images/Error404Image';
import Navbar from '../../layouts/Dashboard/components/Navbar/Navbar';
import styles from './Error404.module.scss';

const Error404 = () => {
  const navigate = useNavigate();
  const t = useTranslations('errors');

  const handleNavigateToHome = () => {
    navigate('/', { replace: true });
  };

  useEffect(() => {
    window.document.title = `${t('notFound.documentTitle')} - CASA Retail AI`;
  }, [t]);

  return (
    <Box id={styles.error404}>
      <Navbar onToggleSidebar={() => {}} hideSidebar />
      <Box className={styles.error404Body}>
        <Box>
          <Error404Image />
        </Box>
        <Box className={styles.error404Info}>
          <Typography className={styles.error404InfoTitle} variant='h3'>
            {t('notFound.title')}
          </Typography>
          <Typography className={styles.error404InfoDescription}>
            {t.rich('notFound.description', {
              br: () => <br />,
              code: (chunks) => (
                <Typography component='code' color='primary.main'>
                  {chunks}
                </Typography>
              ),
            })}
          </Typography>
          <Button size='large' onClick={handleNavigateToHome}>
            {t('backToHome')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
export default Error404;
